import { api } from './client';

export async function fetchSolanaTransaction(signature) {
  const { data } = await api.get(`/v1/transactions/${encodeURIComponent(signature)}`);
  return data;
}

export async function fetchTronTransaction(hash) {
  const { data } = await api.get(`/v1/tron/transactions/${encodeURIComponent(hash.toLowerCase())}`);
  return data;
}

export async function fetchSolanaBlock(slot) {
  const { data } = await api.get(`/v1/solana/blocks/${encodeURIComponent(slot)}`);
  return data;
}

export async function fetchTronBlock(number) {
  const { data } = await api.get(`/v1/tron/blocks/${encodeURIComponent(number)}`);
  return data;
}

export async function fetchEvmTransaction(hash, chain = null) {
  const params = chain ? { chain } : {};
  const { data } = await api.get(`/v1/evm/transactions/${encodeURIComponent(hash.toLowerCase())}`, { params });
  return data;
}

export async function fetchEvmBlock(number, chain = null) {
  const params = chain ? { chain } : {};
  const { data } = await api.get(`/v1/evm/blocks/${encodeURIComponent(number)}`, { params });
  return data;
}

export async function resolveBlock(query) {
  const { data } = await api.get(`/v1/blocks/resolve/${encodeURIComponent(query)}`);
  return data;
}

export async function fetchPrcTransaction(hash) {
  const { data } = await api.get(`/v1/prc/transactions/${encodeURIComponent(hash)}`);
  return data;
}

export async function fetchPrcBlock(number, page = 1) {
  const { data } = await api.get(`/v1/prc/blocks/${encodeURIComponent(number)}`, { params: { page } });
  return data;
}

export async function fetchPrcWallet(address, page = 1) {
  const { data } = await api.get(`/v1/prc/wallet/${encodeURIComponent(address)}`, { params: { page } });
  return data;
}

export async function fetchRecentPrcTransactions(page = 1, perPage = 20) {
  const { data } = await api.get('/v1/prc/transactions/recent', { params: { page, per_page: perPage } });
  return data;
}

export async function fetchPrcPrice() {
  const { data } = await api.get('/v1/prc/price');
  return data;
}

export async function fetchPrcFee() {
  const { data } = await api.get('/v1/prc/fee');
  return data;
}
